const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35,0,0,0.35,11,11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "server--1-",
    serifId: "server (1)",
    transform: "matrix(1,0,0,1,-30,-30)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,6.5C8.019,6.5 6,8.519 6,11C6,13.481 8.019,15.5 10.5,15.5C12.981,15.5 15,13.481 15,11C15,8.519 12.981,6.5 10.5,6.5ZM10.5,13.5C9.122,13.5 8,12.379 8,11C8,9.621 9.122,8.5 10.5,8.5C11.878,8.5 13,9.621 13,11C13,12.379 11.878,13.5 10.5,13.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 9.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 9.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 12.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 12.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 9.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 12.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 9.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 12.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 9.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 12.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,16.892L60,5.108C60,2.567 57.933,0.5 55.392,0.5L4.608,0.5C2.067,0.5 0,2.567 0,5.108L0,16.891C0,18.36 0.703,19.655 1.777,20.499C0.703,21.344 0,22.64 0,24.108L0,35.891C0,37.36 0.703,38.655 1.777,39.499C0.703,40.344 0,41.64 0,43.108L0,54.891C0,57.433 2.067,59.5 4.608,59.5L55.391,59.5C57.932,59.5 59.999,57.433 59.999,54.892L59.999,43.108C59.999,41.639 59.296,40.344 58.222,39.5C59.297,38.656 60,37.36 60,35.892L60,24.108C60,22.639 59.297,21.344 58.223,20.5C59.297,19.656 60,18.36 60,16.892ZM58,43.108L58,54.891C58,56.329 56.83,57.499 55.392,57.499L4.608,57.499C3.17,57.5 2,56.33 2,54.892L2,43.108C2,41.67 3.17,40.5 4.608,40.5L55.391,40.5C56.83,40.5 58,41.67 58,43.108ZM58,24.108L58,35.891C58,37.329 56.83,38.499 55.392,38.499L4.608,38.499C3.17,38.5 2,37.33 2,35.892L2,24.108C2,22.67 3.17,21.5 4.608,21.5L55.391,21.5C56.83,21.5 58,22.67 58,24.108ZM4.608,19.5C3.17,19.5 2,18.33 2,16.892L2,5.108C2,3.67 3.17,2.5 4.608,2.5L55.391,2.5C56.83,2.5 58,3.67 58,5.108L58,16.891C58,18.329 56.83,19.499 55.392,19.499L4.608,19.499L4.608,19.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,34.5C12.981,34.5 15,32.481 15,30C15,27.519 12.981,25.5 10.5,25.5C8.019,25.5 6,27.519 6,30C6,32.481 8.019,34.5 10.5,34.5ZM10.5,27.5C11.878,27.5 13,28.621 13,30C13,31.379 11.878,32.5 10.5,32.5C9.122,32.5 8,31.379 8,30C8,28.621 9.122,27.5 10.5,27.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 28.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 28.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 31.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 31.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 28.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 31.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 28.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 31.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 28.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 31.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,53.5C12.981,53.5 15,51.481 15,49C15,46.519 12.981,44.5 10.5,44.5C8.019,44.5 6,46.519 6,49C6,51.481 8.019,53.5 10.5,53.5ZM10.5,46.5C11.878,46.5 13,47.621 13,49C13,50.379 11.878,51.5 10.5,51.5C9.122,51.5 8,50.379 8,49C8,47.621 9.122,46.5 10.5,46.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 47.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 47.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 50.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 50.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 47.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 50.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 47.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 47.5,
    r: 1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 50.5,
    r: 1,
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasters);
export default __webpack_public_path__ + "static/media/masters.26000d1e78186dd09a963051f628b38b.svg";
export { ForwardRef as ReactComponent };